export class LojistikIrsaliye {
    subeKodu: number;
    irsaliyeNo: string;
    tarih: Date;
    cariKodu: string;
    tasiyiciVkn: string;
    back:Boolean;

    constructor(obj?: any) {
        if (obj == null) {
            return;
        }
        Object.assign(this, obj);
    }
}
